import type { FlowV2_Update_Metadata } from '~/graphql/types';

const hasDuplicateFlowMetadata = (
  flowMetadata: Array<FlowV2_Update_Metadata>,
) => {
  if (flowMetadata.length === 0) return false;
  const ids = flowMetadata.map(item => item.flowBlueprintActionId);
  return ids.some((id, index) => ids.indexOf(id) !== index);
};

export default hasDuplicateFlowMetadata;
